import { createFileRoute } from '@tanstack/react-router';
import { Heading } from 'components/Heading';
import { FileManager } from 'components/FileManager';
import { emitMessage } from 'engine/api';
import { fileManagerDriver } from 'engine/fileManagerDriver';

export const Route = createFileRoute('/dashboard/media/')({
	component: RouteComponent,
	loader: async () => {
		const res = await emitMessage({ kind: 'media-list-directory', folderId: null });
		return { directory: res.media };
	},
});

function RouteComponent() {
	const { directory } = Route.useLoaderData();

	return (
		<div className="flex h-full flex-col gap-4 overflow-hidden">
			<Heading>Media library</Heading>

			{!directory && <div>Directory not found.</div>}

			{directory && <FileManager driver={fileManagerDriver} directory={directory} mode="standalone" />}
		</div>
	);
}
